import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { Button } from "../input/Button";
import { Column } from "../layout/Column";

export function OpenLinkModal({ reason, destinationUrl, onClose }) {
  return (
    <Modal
      title={<FormattedMessage id="open-link-modal.title" defaultMessage="Open Link Warning" />}
      beforeTitle={<CloseButton onClick={onClose} />}
    >
      <Column padding center="both" grow>
        <p>{reason}</p>
        <br />
        <Button
          as="a"
          preset="primary"
          href={destinationUrl}
          rel="noopener noreferrer"
          target="_blank"
          onClick={onClose}
        >
          <FormattedMessage id="open-link-modal.confirm" defaultMessage="Open Link" />
        </Button>
      </Column>
    </Modal>
  );
}

OpenLinkModal.propTypes = {
  reason: PropTypes.string,
  destinationUrl: PropTypes.string,
  onClose: PropTypes.func
};
